import { render, staticRenderFns } from "./helpToAccessLocation.vue?vue&type=template&id=185baee5&scoped=true&"
import script from "./helpToAccessLocation.vue?vue&type=script&lang=js&"
export * from "./helpToAccessLocation.vue?vue&type=script&lang=js&"
import style0 from "./helpToAccessLocation.vue?vue&type=style&index=0&id=185baee5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185baee5",
  null
  
)

export default component.exports